import FloatButton from "./FloatButton";

export default function SkillsButton() {
  return <div style={{ position: 'absolute', top: '225px', left: '1020px' }}>
    <FloatButton text="Skills" />
  </div>;
}
